<template>
  <section id="games" class="games section">
    <div class="section-heading reveal-up">
      <h2>Also from Zearloops</h2>
    </div>

    <div class="featured-games featured-games--support reveal-up">
      <article class="game-card game-card--support" v-for="game in supportGames" :key="game.slug">
        <div class="game-card-heading">
          <div class="game-image-wrap">
            <img
              v-if="game.image"
              :src="game.image"
              :alt="game.imageAlt"
              class="game-image"
              width="96"
              height="96"
              loading="lazy"
              decoding="async"
            >
            <div v-else class="game-artwork-placeholder" aria-hidden="true">
              <span>{{ game.monogram }}</span>
            </div>
          </div>

          <div class="game-card-title">
            <h3>
              <router-link :to="`/game/${game.slug}`">{{ game.title }}</router-link>
            </h3>
            <p class="game-genre">{{ game.genre }}</p>
          </div>
        </div>

        <div class="game-copy">
          <p class="game-description">{{ game.description }}</p>

          <div class="game-card-actions">
            <p class="game-status">{{ game.status === 'available' ? 'Available now' : game.statusLabel }}</p>
            <a
              v-if="game.storeUrl"
              :href="game.storeUrl"
              target="_blank"
              rel="noopener noreferrer"
              class="store-button android-button"
              :aria-label="`Get ${game.title} on Google Play`"
            >
              <svg viewBox="0 0 24 24" class="store-icon" aria-hidden="true">
                <path :d="mdiAndroid" />
              </svg>
              <span>Get it on Google Play</span>
            </a>
            <router-link v-else class="game-cta" :to="`/game/${game.slug}`">Explore {{ game.title }}</router-link>
          </div>
        </div>
      </article>
    </div>

    <div class="pipeline-section reveal-up">
      <h3>Planned games</h3>
      <ul class="pipeline-list">
        <li v-for="game in pipelineGames" :key="game.slug">
          <span class="pipeline-title">{{ game.title }}</span>
          <span class="pipeline-genre">{{ game.genre }}</span>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import { mdiAndroid } from '@mdi/js';
import { games } from '@/data/games';

export default {
  name: 'PortfolioSection',
  data() {
    return {
      games,
      mdiAndroid
    };
  },
  computed: {
    supportGames() {
      return this.games.filter(game => game.slug !== 'epic-rifts' && game.status !== 'planned');
    },
    pipelineGames() {
      return this.games.filter(game => game.status === 'planned');
    }
  }
};
</script>
